import { render, staticRenderFns } from "./PatmatchResults.vue?vue&type=template&id=31f8a4be&scoped=true"
import script from "./PatmatchResults.vue?vue&type=script&lang=js"
export * from "./PatmatchResults.vue?vue&type=script&lang=js"
import style0 from "./PatmatchResults.vue?vue&type=style&index=0&id=31f8a4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8a4be",
  null
  
)

export default component.exports